var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { lg: _vm.lg, md: _vm.md, xs: "12" } },
    [
      _vm.project.Contact
        ? _c(
            "w-card",
            [
              _c(
                "w-card-content",
                [
                  _c(
                    "div",
                    { style: { display: "flex", flexDirection: "row" } },
                    [
                      _c("span", { staticClass: "contact" }, [
                        _vm._v(_vm._s(_vm.project.Contact.getDisplayName())),
                      ]),
                    ]
                  ),
                  _vm.project.Contact.MainAddress
                    ? [
                        _c("div", { staticClass: "address" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.project.Contact.MainAddress.AddressLine1
                              )
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.project.Contact.MainAddress.PostalAndCity
                              )
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "props phone mt" }, [
                          _vm.project.Contact.MainAddress.Phone
                            ? _c(
                                "a",
                                {
                                  staticClass: "w-link",
                                  attrs: {
                                    href: _vm.project.Contact.getCleanPhone(),
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "phone-square-alt" },
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm.project.Contact.MainAddress.Phone
                                    )
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.project.Contact.MainAddress.Mobile
                            ? _c(
                                "a",
                                {
                                  staticClass: "ml w-link",
                                  attrs: {
                                    href: _vm.project.Contact.getCleanMobile(),
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "phone-square-alt" },
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm.project.Contact.MainAddress.Mobile
                                    )
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card",
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("properties")))]),
          _c(
            "w-card-content",
            [
              _c("app-project-info-properties", {
                attrs: { project: _vm.project },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }